// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"gT-z","inlineTitle":"hT-z","sponsoredAdsWrapper":"iT-z","marketplaceRecosWrapper":"jT-z"};